import React from 'react';
import { Alert, Box, Button } from '@mui/material';

// Keeps one broken screen from blanking the whole app: a render error inside a tab shows
// a message with a retry instead of a white page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Screen crashed:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Box sx={{ p: 2 }}>
        <Alert
          severity="error"
          action={<Button color="inherit" size="small" onClick={() => this.setState({ error: null })}>Retry</Button>}
        >
          This screen hit a problem and could not be shown. {String(this.state.error?.message || '')}
        </Alert>
      </Box>
    );
  }
}

export default ErrorBoundary;
